export default __webpack_public_path__ + "static/media/delete-bin.e8a6cab1.svg";